import React from 'react'

const Blogs = () => {
  return (
    <div>
      Blogs asds
    </div>
  )
}

export default Blogs
